import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Api from "../../services/api";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import swal from "sweetalert";
import ConteudoEditor from "./ConteudoEditor";

const image_formats = ["image/jpg", "image/jpeg", "image/png"];

const validationSchema = yup.object().shape({
  nome_pt: yup.string().required("Título em PT obrigatório"),
  url: yup
    .string()
    .required("Slug (URL) obrigatório")
    .matches(/^[a-z0-9-]+$/, "Use apenas letras minúsculas, números e hífens"),
  imagem: yup
    .mixed()
    .test("fileSize", "Imagem maior que 2mb.", (file) =>
      file && file.length === 1 ? file[0].size <= 2000000 : true,
    )
    .test("FILE_FORMAT", "Apenas jpg, jpeg e png.", (file) =>
      file && file.length === 1 ? image_formats.includes(file[0].type) : true,
    ),
});

export default function EditGuia({ data, loadGuias, setOpenModalEdit }) {
  const [loading, setLoading] = useState(false);
  const Loader = () => <div className="loading"></div>;
  const [categorias, setCategorias] = useState([]);
  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      conteudo_pt: data.conteudo_pt || "",
      conteudo_en: data.conteudo_en || "",
      conteudo_es: data.conteudo_es || "",
    },
  });

  useEffect(() => {
    Api.get("/guias/categorias/list").then((r) => setCategorias(r.data));
  }, []);

  useEffect(() => {
    setValue("conteudo_pt", data.conteudo_pt || "");
    setValue("conteudo_en", data.conteudo_en || "");
    setValue("conteudo_es", data.conteudo_es || "");
  }, [data, setValue]);

  const onSubmit = (formData) => {
    setLoading(true);
    const imagefile = document.querySelector("#imagem");

    const bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("ativado", formData.ativado ? 1 : 0);
    bodyFormData.append("destaque", formData.destaque ? 1 : 0);
    bodyFormData.append("guias_categorias_id", formData.guias_categorias_id || "");
    bodyFormData.append("url", formData.url);
    bodyFormData.append("autor", formData.autor || "");
    bodyFormData.append("data_publicacao", formData.data_publicacao || "");
    bodyFormData.append("nome_pt", formData.nome_pt || "");
    bodyFormData.append("nome_en", formData.nome_en || "");
    bodyFormData.append("nome_es", formData.nome_es || "");
    bodyFormData.append("resumo_pt", formData.resumo_pt || "");
    bodyFormData.append("resumo_en", formData.resumo_en || "");
    bodyFormData.append("resumo_es", formData.resumo_es || "");
    bodyFormData.append("conteudo_pt", formData.conteudo_pt || "");
    bodyFormData.append("conteudo_en", formData.conteudo_en || "");
    bodyFormData.append("conteudo_es", formData.conteudo_es || "");
    if (imagefile && imagefile.files.length > 0) {
      bodyFormData.append("imagem", imagefile.files[0]);
      bodyFormData.append("oldimage", data.imagem || "");
    }

    const axiosConfig = {
      headers: { "Content-Type": "multipart/form-data" },
    };

    Api.post("/guias/edit", bodyFormData, axiosConfig)
      .then((response) => {
        if (response.data.status === "success") {
          swal("Sucesso!", response.data.message, "success");
          loadGuias();
          setOpenModalEdit(false);
        } else {
          swal("Erro!", response.data.message, "error");
        }
        setLoading(false);
      })
      .catch((err) => {
        swal("Erro!", "ops! ocorreu um erro: " + err, "error");
        setLoading(false);
      });
  };

  const dataPubInput = data.data_publicacao
    ? data.data_publicacao.replace(" ", "T").substring(0, 16)
    : "";

  return (
    <>
      {loading ? <Loader /> : null}
      <h2>Editar Guia</h2>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <Grid container className="form">
          <Grid item lg={6} md={6} sm={12} className="field">
            <label>Categoria</label>
            <select
              {...register("guias_categorias_id")}
              defaultValue={data.guias_categorias_id || ""}
            >
              <option value="">Selecione...</option>
              {categorias.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.nome_pt}
                </option>
              ))}
            </select>
          </Grid>
          <Grid item lg={6} md={6} sm={12} className="field">
            <label>Slug (URL)</label>
            <input type="text" defaultValue={data.url} {...register("url")} />
            <span className="error">{errors.url?.message}</span>
          </Grid>
          <Grid item lg={6} md={6} sm={12} className="field">
            <label>Autor</label>
            <input type="text" defaultValue={data.autor || ""} {...register("autor")} />
          </Grid>
          <Grid item lg={6} md={6} sm={12} className="field">
            <label>Data de publicação</label>
            <input
              type="datetime-local"
              defaultValue={dataPubInput}
              {...register("data_publicacao")}
            />
          </Grid>
          <Grid item lg={6} md={6} sm={12} className="field">
            <label>Imagem de capa</label>
            <input type="file" id="imagem" name="imagem" {...register("imagem")} />
            <span className="error">{errors.imagem?.message}</span>
            {data.imagem && (
              <img
                src={process.env.REACT_APP_FILES_URL + data.imagem}
                style={{ maxWidth: "200px", marginTop: 8 }}
                alt=""
              />
            )}
          </Grid>
          <Grid item lg={3} md={3} sm={6} className="field">
            <label>
              <input
                type="checkbox"
                defaultChecked={!!data.ativado && data.ativado != 0}
                {...register("ativado")}
              />{" "}
              Publicado
            </label>
          </Grid>
          <Grid item lg={3} md={3} sm={6} className="field">
            <label>
              <input
                type="checkbox"
                defaultChecked={!!data.destaque && data.destaque != 0}
                {...register("destaque")}
              />{" "}
              Destaque
            </label>
          </Grid>
          <Grid item lg={12} className="field">
            <Tabs>
              <TabList>
                <Tab>
                  <img src={process.env.PUBLIC_URL + "/images/flag-pt.png"} alt="" />
                </Tab>
                <Tab>
                  <img src={process.env.PUBLIC_URL + "/images/flag-us.png"} alt="" />
                </Tab>
                <Tab>
                  <img src={process.env.PUBLIC_URL + "/images/flag-es.png"} alt="" />
                </Tab>
              </TabList>
              <TabPanel>
                <Grid item lg={12} className="field">
                  <label>Título (PT)</label>
                  <input
                    type="text"
                    defaultValue={data.nome_pt}
                    {...register("nome_pt")}
                  />
                  <span className="error">{errors.nome_pt?.message}</span>
                </Grid>
                <Grid item lg={12} className="field">
                  <label>Resumo (PT)</label>
                  <textarea
                    defaultValue={data.resumo_pt || ""}
                    {...register("resumo_pt")}
                    rows="4"
                  ></textarea>
                </Grid>
                <Grid item lg={12} className="field">
                  <label>Conteúdo (PT)</label>
                  <Controller
                    name="conteudo_pt"
                    control={control}
                    render={({ field }) => (
                      <ConteudoEditor value={field.value} onChange={field.onChange} />
                    )}
                  />
                </Grid>
              </TabPanel>
              <TabPanel>
                <Grid item lg={12} className="field">
                  <label>Título (EN)</label>
                  <input
                    type="text"
                    defaultValue={data.nome_en || ""}
                    {...register("nome_en")}
                  />
                </Grid>
                <Grid item lg={12} className="field">
                  <label>Resumo (EN)</label>
                  <textarea
                    defaultValue={data.resumo_en || ""}
                    {...register("resumo_en")}
                    rows="4"
                  ></textarea>
                </Grid>
                <Grid item lg={12} className="field">
                  <label>Conteúdo (EN)</label>
                  <Controller
                    name="conteudo_en"
                    control={control}
                    render={({ field }) => (
                      <ConteudoEditor value={field.value} onChange={field.onChange} />
                    )}
                  />
                </Grid>
              </TabPanel>
              <TabPanel>
                <Grid item lg={12} className="field">
                  <label>Título (ES)</label>
                  <input
                    type="text"
                    defaultValue={data.nome_es || ""}
                    {...register("nome_es")}
                  />
                </Grid>
                <Grid item lg={12} className="field">
                  <label>Resumo (ES)</label>
                  <textarea
                    defaultValue={data.resumo_es || ""}
                    {...register("resumo_es")}
                    rows="4"
                  ></textarea>
                </Grid>
                <Grid item lg={12} className="field">
                  <label>Conteúdo (ES)</label>
                  <Controller
                    name="conteudo_es"
                    control={control}
                    render={({ field }) => (
                      <ConteudoEditor value={field.value} onChange={field.onChange} />
                    )}
                  />
                </Grid>
              </TabPanel>
            </Tabs>
          </Grid>
        </Grid>
        <div className="actions">
          <button type="submit" className="save">
            Salvar
          </button>
          <a href="#" className="cancel" onClick={() => setOpenModalEdit(false)}>
            Cancelar
          </a>
        </div>
      </form>
    </>
  );
}
